import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import { invalidateAutomationTemplateQuery } from '../../queries/useAutomationTemplateQuery';

interface Params {
	templateId: string;
	stepId: string;
	caseId: string;
	caseData: Api.IAutomationStepCaseStatement;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepSwitchUpdateCaseMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ISwitchAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ templateId, stepId, caseId, caseData, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.ISwitchAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Switch/${encodeURIComponent(
						stepId
					)}/Case/${encodeURIComponent(caseId)}`,
					impersonationContext,
				}),
				'PUT',
				caseData
			);
		},
		onError,
		onSuccess: (data, variables) => {
			// Invalidate the parent template query to refresh UI with updated case data
			invalidateAutomationTemplateQuery(variables.templateId);
			// Also invalidate the child template if it exists
			if (variables.caseData.automationTemplateId) {
				invalidateAutomationTemplateQuery(variables.caseData.automationTemplateId);
			}
			onSuccess?.(data, variables);
		},
	});
}
